import { TypedFormInput, TypedFormInputInGroup } from '~/components/form-v2/types'
import { SimpleTableColumn } from '~/components/table-settings/types'
import { FormulaFieldReference } from './types'

/**
 * Converts a SimpleTableColumn to a FormulaFieldReference
 * This is used when integrating FormulaBuilder with table columns
 */
export function tableColumnToFieldReference(column: SimpleTableColumn): FormulaFieldReference {
  return {
    id: column.id,
    name: column.name,
    type: column.type,
    innerType: column.innerType,
    contextName: column.table.name,
    contextId: column.table.id,
    fieldType: 'tableColumn',
    lookupColumn: column.lookupColumn
      ? {
          id: column.lookupColumn.id,
          name: column.lookupColumn.id, // SimpleTableColumn lookupColumn doesn't have name, use id
          type: column.lookupColumn.type,
        }
      : null,
  }
}

/**
 * Converts an array of SimpleTableColumns to FormulaFieldReferences
 */
export function tableColumnsToFieldReferences(
  columns: SimpleTableColumn[],
): FormulaFieldReference[] {
  return columns.map(tableColumnToFieldReference)
}

/**
 * Converts form input blocks to FormulaFieldReferences
 * This is used when integrating FormulaBuilder with form inputs (e.g., for LOOKUP filters)
 */
export function formInputsToFieldReferences(
  formBlocks: (TypedFormInput | TypedFormInputInGroup)[],
  formId: string,
  formName?: string,
): FormulaFieldReference[] {
  return formBlocks.map((block) => {
    return {
      id: block.id,
      name: block.label || 'Untitled',
      type: block.dataType,
      innerType: block.innerDataType,
      contextName: formName || 'Form',
      contextId: formId,
      fieldType: 'formInput',
      lookupColumn: block.lookupTableColumn
        ? {
            id: block.lookupTableColumn.id,
            name: block.lookupTableColumn.name,
            type: block.lookupTableColumn.type,
          }
        : null,
    }
  })
}
